<script>
import { mapGetters } from 'vuex';
import modalUtilizeComponent from '@/components/modals/utilize/utilize.vue';
import modalSendFBAComponent from '@/components/modals/send_FBA/send_FBA.vue';
import modalSendFBMComponent from '@/components/modals/send_FBM/send_FBM.vue';
import changeConditionComponent from '@/components/modals/change_condition/change_condition.vue';
import editProducts from '@/components/modals/edit_products/edit_products.vue';
import productGroupComponent from '@/components/table_product_group/table_product_group.vue';

export default {
  data() {
    return {
      selected: [],
      rightsClient: ['client', 'admin'],
      rightsWorker: ['worker', 'admin'],
      filters: {
        search: '',
      },
      placeholder_text: 'Search by asin, product title, worker comment, client comment',
    };
  },
  watch: {
    product_groups: {
      handler(data) {
        this.selected = data.map((item) => item.filter((subItem) => subItem.selected));
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({ modal_edit_products: 'modal_edit_products' }),
    loaded() {
      return this.$store.state.inStock.loaded;
    },
    modal_condition() {
      return this.$store.state.inStock.modal_condition;
    },
    modal_delete() {
      return this.$store.state.inStock.modal_delete;
    },
    product_groups() {
      return this.$store.state.inStock.product_groups;
    },
    modal_utilize() {
      return this.$store.state.inStock.modal_utilize;
    },
    modal_send_fba() {
      return this.$store.state.inStock.modal_send_fba;
    },
    modal_send_fbm() {
      return this.$store.state.inStock.modal_send_fbm;
    },
    isSelectedEmpty() {
      return this.selected.reduce((sum, cur) => sum + cur.length, 0);
    },
    user_role() {
      return this.$store.state.users.role;
    },
    chosen_client() {
      return this.$store.state.users.chosen_client;
    },
    app_section() {
      return this.$store.getters.get_app_section;
    },
    filteredProducts() {
      if (this.product_groups.length === 0) {
        return [];
      }

      return this.product_groups.filter((group) => {
        const asin = (group.filter((product) => (
          product.asin.toLowerCase().includes(this.filters.search.toLowerCase())
        ))).length > 0;

        const productTitle = (group.filter((product) => (
          product.title.toLowerCase().includes(this.filters.search.toLowerCase())
        ))).length > 0;

        const workerComment = (group.filter((product) => {
          if (product.worker_comment === null) return false;

          return product.worker_comment.toLowerCase().includes(this.filters.search.toLowerCase());
        })).length > 0;

        const clientComment = (group.filter((product) => {
          if (product.client_comment === null) return false;

          return product.client_comment.toLowerCase().includes(this.filters.search.toLowerCase());
        })).length > 0;

        return asin || productTitle || workerComment || clientComment;
      });
    },
  },
  created() {
    this.$store.dispatch('isset_loaded', false);

    if (this.rightsWorker.indexOf(this.user_role) !== -1 && !this.chosen_client) {
      this.$router.push({ name: `${this.app_section}-clients` });
      return;
    }
    this.$store.dispatch('isget_list');
  },
  components: {
    modalUtilize_component: modalUtilizeComponent,
    modalSendFBA_component: modalSendFBAComponent,
    modalSendFBM_component: modalSendFBMComponent,
    change_condition_component: changeConditionComponent,
    productGroup_component: productGroupComponent,
    edit_products_component: editProducts,
  },
  methods: {
    show_modal(type) {
      this.$store.dispatch(`isset_selected_${type}`, true);
    },
    set_search(str) {
      this.filters.search = str;
    },
    changeCondition(product) {
      this.$store.commit('set_modal_condition', { ...product });
    },
    editProducts(product) {
      this.$store.commit('set_modal_edit_products', { ...product });
    },
    showDeleteGroupModal(group) {
      const ids = group.reduce((acc, current) => {
        acc.push(...current.ids.map(Number));
        return acc;
      }, []);

      this.$store.commit('set_modal_inform', {
        type: 'delete',
        action: 'isremove_products',
        action_data: ids,
        inform_message: {
          0: this.goodConditions,
          1: this.badConditions,
          2: this.attentionConditions,
        },
      });
    },
    showDeleteProductsModal(product, condition, quantity) {
      const ids = product.ids.reduce((acc, current) => {
        acc.push(Number(current));
        return acc;
      }, []);

      const data = {
        type: 'delete',
        action: 'isremove_products',
        action_data: ids,
      };

      if (condition === 0) {
        data.inform_message = {
          [condition]: quantity,
        };
      }

      this.$store.commit('set_modal_inform', data);
    },
  },
};
</script>
<template src="./in-stock.pug" lang="pug"></template>
<style src="./in-stock.styl" lang="stylus"></style>
